module.exports = __webpack_public_path__ + "img/太子参.8bafabbf.jpg";